import { ActionType, createAsyncAction } from 'typesafe-actions'
import { CampaignState } from '../../types'
import { Failure, Request, Success } from './types'

export const fetchCampaignByIdAction = createAsyncAction(
  '@campaign/FETCH_CAMPAIGN_BY_ID_REQUEST',
  '@campaign/FETCH_CAMPAIGN_BY_ID_SUCCESS',
  '@campaign/FETCH_CAMPAIGN_BY_ID_FAILURE'
)<Request, Success, Failure>()

const request = (state: CampaignState): CampaignState => ({
  ...state,
  isLoadingFetchCampaignById: true
})

const success = (state: CampaignState, action: ActionType<typeof fetchCampaignByIdAction.success>): CampaignState => {
  return {
    ...state,
    campaign: action.payload.campaign,
    isSuccessFetchCampaignById: true,
    isLoadingFetchCampaignById: false
  }
}

const failure = (state: CampaignState): CampaignState => {
  return {
    ...state,
    isLoadingFetchCampaignById: false,
    isErrorFetchCampaignById: true
  }
}

export const fetchCampaignByIdHandle = {
  asyncAction: fetchCampaignByIdAction,
  request,
  success,
  failure
}
